import { InjectionKey, reactive, toRefs } from 'vue';
import { ModalProgram } from '@/modules/ModalProgram';
import { Program, _Program } from '@/modules/Program';

type StateType = {
  state: boolean;
  item?: ModalProgram;
  mode: 'modeProgram' | 'modeBroadcast' | 'modeMylist';
  futurePrograms: (_Program | Program)[];
};

export const useProgramModal = () => {
  const modalState: StateType = reactive({
    state: false,
    item: undefined,
    mode: 'modeProgram',
    futurePrograms: [],
  });

  const open = (item: StateType['item'], mode: StateType['mode']) => {
    modalState.item = item;
    modalState.mode = mode;
    if (modalState.item) {
      modalState.state = true;
    }
  };

  const close = () => {
    modalState.state = false;
    modalState.futurePrograms = [];
  };

  return {
    ...toRefs(modalState),
    open,
    close,
  };
};

export type ProgramModal = ReturnType<typeof useProgramModal>;
export const ProgramModalKey: InjectionKey<ProgramModal> = Symbol('programModal');
